import { CommonModule, DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CoreModule } from '@app/core/core.module';
import { AppErrorHandler } from '@app/core/services/app-error-handler.service';
import { SharedModule } from '@app/shared/shared.module';
import * as Sentry from '@sentry/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        AppRoutingModule,
        CommonModule,
        CoreModule,
        BrowserModule,
        SharedModule,
    ],
    providers: [
        {
            provide: ErrorHandler,
            useClass: AppErrorHandler,
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: DATE_PIPE_DEFAULT_OPTIONS,
            useValue: {},
        },
        provideAppInitializer(
            () => {
                inject(Sentry.TraceService);
            },
        ),
        provideHttpClient(
            withXhr(),
            withInterceptorsFromDi(),
        ),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor() {
    }
}
